import { app } from '../../../app';
import {Controller} from "./roles-help.controller";

app.component('companyRolesHelp', {
    bindings: {currentCompany: '<'},
    templateUrl: require('./roles-help.html'),
    controller:Controller
});



// WEBPACK FOOTER //
// ./src/portal/states/company/roles-help/roles-help.component.js